import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { login as loginService } from "../../services/authService";
import { useAuth } from "../../auth/AuthProvider";
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";

const LoginForm = ({ registerPath, resetPath }) => {
  const emailRef = useRef();
  const passwordRef = useRef();
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, def = "") => translations[key] || def;

  // Sayfa ilk açıldığında localStorage'da kayıtlı email varsa al
  useEffect(() => {
    const savedEmail = localStorage.getItem("savedEmail");
    if (savedEmail) {
      emailRef.current.value = savedEmail;
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const email = emailRef.current.value.trim();
    const password = passwordRef.current.value;

    try {
      const data = await loginService(email, password);
      if (data.user.role === "sales" || data.user.role === "Sales") {
        setError("Bu siteye erişim yetkiniz bulunmamaktadır.");
        return; // token ve diğer şeyler kaydedilmesin!
      }

      // hangi storage'ı kullanacağımızı seç

      const storage = localStorage;

      // Token ve user bilgilerini sakla
      storage.setItem("admin_token", data.token);
      storage.setItem("admin_id", data.user.id);
      storage.setItem("userRole", data.user.role);
      storage.setItem("language", data.user.language);

      // İzinleri çek ve storage'a yaz
      const resp = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/my-permissions`,
        { headers: { Authorization: `Bearer ${data.token}` } }
      );
      const result = await resp.json();
      if (Array.isArray(result.permissions)) {
        storage.setItem("permissions", JSON.stringify(result.permissions));
      }

      // “Beni Hatırla” için e-postayı sakla veya sil
      if (rememberMe) {
        localStorage.setItem("savedEmail", email);
      } else {
        localStorage.removeItem("savedEmail");
      }

      // Auth context ve yönlendirme
      login(data.token);
      navigate("/");
    } catch (err) {
      setError(getText("ERROR_LOGIN_FAILED"));
    }

    // güvenlik için hemen temizle
    passwordRef.current.value = "";
  };

  return (
    <>
      <h2 className="fs-20 fw-bolder mb-4">
        {getText("LOGIN_TITLE")}
      </h2>
      <h4 className="fs-13 fw-bold mb-2">
        {getText("LOGIN_SUBTITLE")}
      </h4>

      {error && <p style={{ color: "red", fontWeight: "bold" }}>{error}</p>}

      <form onSubmit={handleSubmit} className="w-100 mt-4 pt-2">
        <div className="mb-4">
          <input
            ref={emailRef}
            type="email"
            className="form-control"
            placeholder={getText("LOGIN_EMAIL_PLACEHOLDER")}
            required
          />
        </div>
        <div className="mb-3">
          <input
            ref={passwordRef}
            type="password"
            className="form-control"
            placeholder={getText("LOGIN_PASSWORD_PLACEHOLDER")}
            required
          />
        </div>

        <div className="d-flex align-items-center justify-content-between">
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id="rememberMe"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <label
              className="custom-control-label c-pointer"
              htmlFor="rememberMe"
            >
              {getText("REMEMBER_ME")}
            </label>
          </div>
        </div>

        <div className="mt-5">
          <button type="submit" className="btn btn-lg btn-primary w-100">
            {getText("LOGIN_BUTTON")}
          </button>
        </div>
      </form>
    </>
  );
};

export default LoginForm;
